var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReviewProduct(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#212B36;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17.2,12.5L16,10.1l-1.2,2.4c-0.1,0.2-0.3,0.4-0.5,0.4l-2.7,0.4l1.9,1.9c0.2,0.2,0.2,0.4,0.2,0.6l-0.5,2.7 l2.4-1.3c0.2-0.1,0.4-0.1,0.7,0l2.4,1.3l-0.5-2.7c0-0.2,0-0.5,0.2-0.6l1.9-1.9l-2.7-0.4C17.5,12.9,17.3,12.7,17.2,12.5L17.2,12.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25.4,4H6.6C5.2,4,4,5.2,4,6.6v15.8C4,23.8,5.2,25,6.6,25h6.1l2.8,2.8c0.1,0.1,0.3,0.2,0.5,0.2 s0.4-0.1,0.5-0.2l2.8-2.8h6.1c1.4,0,2.6-1.2,2.6-2.6V6.6C28,5.2,26.8,4,25.4,4L25.4,4z M22.4,13.3l-2.7,2.6l0.6,3.7 c0,0.1,0,0.1,0,0.2c0,0.4-0.3,0.7-0.7,0.7c0,0,0,0,0,0c-0.1,0-0.2,0-0.3-0.1L16,18.6l-3.3,1.8c-0.2,0.1-0.5,0.1-0.7-0.1 c-0.2-0.2-0.3-0.4-0.3-0.7l0.6-3.7l-2.7-2.6c-0.2-0.2-0.3-0.5-0.2-0.7c0.1-0.3,0.3-0.4,0.6-0.5l3.7-0.5l1.7-3.4 c0.1-0.2,0.4-0.4,0.6-0.4s0.5,0.2,0.6,0.4l1.7,3.4l3.7,0.5c0.3,0,0.5,0.2,0.6,0.5C22.7,12.8,22.6,13.1,22.4,13.3L22.4,13.3z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviewProduct);
export default __webpack_public_path__ + "static/media/review_product.c0b91e3e9d2d8ed0695c9a83633f9f93.svg";
export { ForwardRef as ReactComponent };